import React from 'react';
import { BookOpen, FileText, Target, MessageSquare, BarChart3, Map, Clock, Award } from 'lucide-react';
import { mockData } from '../utils/mock';

const iconMap = {
  0: BookOpen,
  1: Target,
  2: MessageSquare,
  3: MessageSquare,
  4: BarChart3,
  5: Map
};

export const ProgramModules = () => {
  return (
    <section id="modulos" className="relative py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Qué Incluye el Programa
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Un programa estructurado en 6 módulos diseñados para transformar tu forma de decidir
          </p>
        </div>

        {/* Modules Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {mockData.modules.map((module, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={index}
                className="group relative p-8 bg-gradient-to-br from-zinc-900 to-black border border-white/10 rounded-2xl hover:border-orange-500/50 transition-all duration-300 hover:scale-105"
              >
                {/* Module Number Badge */}
                <div className="absolute -top-4 -right-4 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <span className="text-white font-bold text-lg">{module.number}</span>
                </div>

                {/* Icon */}
                <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500/20 rounded-xl mb-6 group-hover:bg-orange-500/30 transition-colors duration-300">
                  <Icon className="w-8 h-8 text-orange-500" />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-orange-500 transition-colors duration-300">
                  {module.title}
                </h3>
                <p className="text-white/70 leading-relaxed">
                  {module.description}
                </p>

                {/* Hover Accent */}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-orange-500 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-b-2xl"></div>
              </div>
            );
          })}
        </div>

        {/* Program Includes */}
        <div className="max-w-4xl mx-auto">
          <div className="p-8 bg-gradient-to-br from-orange-500/10 via-transparent to-transparent border border-orange-500/20 rounded-2xl">
            <h3 className="text-2xl font-bold text-white mb-8 text-center">
              El programa incluye:
            </h3>
            <div className="grid sm:grid-cols-2 gap-6">
              {mockData.programIncludes.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 group"
                >
                  <div className="flex-shrink-0 w-2 h-2 rounded-full bg-orange-500 group-hover:scale-150 transition-transform duration-300"></div>
                  <p className="text-white/90 group-hover:text-white transition-colors duration-300">
                    {item}
                  </p>
                </div>
              ))}
            </div>

            {/* Special Badges */}
            <div className="flex flex-wrap justify-center gap-4 mt-8 pt-8 border-t border-white/10">
              <div className="flex items-center gap-2 px-4 py-2 bg-black/40 rounded-full border border-orange-500/30">
                <Clock className="w-5 h-5 text-orange-500" />
                <span className="text-white/90 text-sm font-medium">Acceso 12 meses</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-black/40 rounded-full border border-orange-500/30">
                <Award className="w-5 h-5 text-orange-500" />
                <span className="text-white/90 text-sm font-medium">Certificación final</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
